export enum ElementSettingsTypeTable {
  'open-ended' = 'es_open_ended',
  'single-choice' = 'es_single_choice',
  'multiple-choice' = 'es_multiple_choice',
  'click-to-rank' = 'es_click_to_rank',
  'drop-down-single-choice' = 'es_drop_down_single_choice',
  'drop-down-multiple-choice' = 'es_drop_down_multiple_choice',
  'numeric' = 'es_numeric',
  'image' = 'es_image',
  'skip-logic' = 'es_skip_logic',
  'voice' = 'es_voice',
  'video' = 'es_video',
  'single-grid' = 'es_single_grid',
  'multiple-grid' = 'es_multiple_grid',
  'display' = 'es_display',
  'location' = 'es_location',
  'hidden' = 'es_hidden'
}
